import React from "react";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";

import Filters from "./components/Filters";
import RegistrationsTable from "./components/Table";
import Totals from "./components/Totals";
import { TournamentRegistrationsProvider } from "./contexts/TournamentRegistrations";

import { IOrder } from "../../../../types/api";

const TournamentRegistrations = (): React.JSX.Element => {
    const { orders } = useLoaderData() as {
        orders: IOrder[];
    };
    const location = useLocation();
    const isOnRegPage =
        /tournament-management\/tournament-registrations\/?$/.test(
            location.pathname,
        );

    return (
        <TournamentRegistrationsProvider initialOrders={orders}>
            {isOnRegPage ? (
                <section
                    className="tournamentRegistrationsContent"
                    data-testid="tournamentRegistrationsContent"
                >
                    <h2>Tournament Registrations</h2>
                    <Filters />
                    <Totals />
                    <RegistrationsTable />
                </section>
            ) : (
                <Outlet />
            )}
        </TournamentRegistrationsProvider>
    );
};

export default TournamentRegistrations;
